/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../api/api';
import { getTokenData } from 'src/utils/api';
import { LOADING_STATUSES } from '../../../constants/statuses';
import { isResponseSuccess, formatFilters } from '../../../utils/api';
import { INITIAL_FILTERS_STATE } from '../constants/referrals';

export const loadReferrals = createAsyncThunk(
  'referrals/loadReferrals',
  async (data, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const { filters, page, per } = getState().referralsReducer;
      const formattedFilters = formatFilters(filters);
      const response = await API(getTokenData()).REFERRALS.load({
        ...formattedFilters,
        offset: page * per,
        limit: per,
      });
      if (isResponseSuccess(response.status)) {
        return {
          data: [
            ...response.data,
          ].map((el) => ({ ...el, id: el.user_id })),
          totalItems: response.total,
        };
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

const initialState = {
  entity: [],
  page: 0,
  per: 100,
  totalItems: 0,
  filters: INITIAL_FILTERS_STATE,
  status: LOADING_STATUSES.IDLE,
  error: null,
};

const referralsSlice = createSlice({
  name: 'referrals',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    setPageData: (state, action) => {
      state.page = action.payload.page;
      state.per = action.payload.per;
    },
    resetReferrals: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadReferrals.pending, (state) => {
        state.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadReferrals.fulfilled, (state, action) => {
        state.entity = action.payload?.data || [];
        state.totalItems = action.payload?.totalItems || 0;
        state.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadReferrals.rejected, (state) => {
        state.status = LOADING_STATUSES.FAILED;
      });
  },
});

export const {
  setFilters,
  setPageData,
  resetReferrals,
} = referralsSlice.actions;
export default referralsSlice.reducer;

export const referralsFilterApply = createAsyncThunk(
  'referrals/filterApply',
  async (newFilters, {
    dispatch,
    rejectWithValue,
  }) => {
    try {
      await dispatch(setFilters({
        ...newFilters,
      }));
      await dispatch(loadReferrals());
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

export const referralsChangePageAction = createAsyncThunk(
  'referrals/referralsChangePageAction',
  async ({
    page = 0,
    per = 0,
  }, {
    dispatch,
    rejectWithValue,
  }) => {
    try {
      await dispatch(setPageData({
        page,
        per,
      }));
      await dispatch(loadReferrals());
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

export const referralsPayout = createAsyncThunk(
  'referrals/payout',
  async (data, {
    dispatch,
    getState,
    rejectWithValue,
  }) => {
    try {
      const response = await API(getTokenData()).REFERRALS.payout(data);
      if (isResponseSuccess(response.status)) {
        await dispatch(loadReferrals());
        return response.data;
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  },
);

export const referralsAttach = createAsyncThunk(
  'referrals/payout',
  async (data, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const response = await API(getTokenData()).REFERRALS.attach(data);
      if (isResponseSuccess(response.status)) {
        return response.data;
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  },
);
